<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-users text-primary mr-2"></i>
                    Gestión de Encuestas
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getQueryRatingsFilteredData()"></export-actions>
                </b-row>

                <b-row class="mb-3">
                    <b-col md="12">
                        <b-row>
                            <b-col md="4">
                                <vue2-date-picker
                                    v-model="filters.dates"
                                    type="date"
                                    range
                                    :format="`DD/MM/YYYY`"
                                    lang="es"
                                    placeholder="Rango de Fechas"
                                    :editable="false"
                                    :first-day-of-week="1"
                                    :shortcuts="datepicker.shortcuts"
                                    class="w-100 date-picker-w-100 date-picker-custom-border"></vue2-date-picker>
                            </b-col>

                            <b-col md="4">
                                <b-form-input
                                    type="number"
                                    v-model="filters.queryNumber"
                                    placeholder="Número Consulta"/>
                            </b-col>

                            <b-col md="4">
                                <adviser-selector v-model="filters.adviser"></adviser-selector>
                            </b-col>
                        </b-row>

                        <b-row class="mt-2">
                            <b-col md="4">
                                <b-form-checkbox type="checkbox" stacked v-model="filters.comments" name="hide">
                                    Tiene observaciones
                                </b-form-checkbox>
                            </b-col>

                            <b-col md="4">
                                <b-form-checkbox type="checkbox" stacked v-model="filters.contact" name="hide">
                                    Solicita ser contactado
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <v-client-table
                    ref="QueryRatingsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="filteredQueryRatings"
                    :options="options"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <i class="fa fa-eye"></i>
                    </template>

                    <template slot="adviser" slot-scope="props">
                        {{ props.row.adviser.name }}
                    </template>

                    <template slot="createdAt" slot-scope="props">
                        {{props.row.createdAt | dateFormat('DD/MM/YYYY HH:mm')}}
                    </template>
                </v-client-table>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapState} from 'vuex'
    import {getQueryRatings} from '@/api/query-rating-api';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import Vue2DatePicker from 'vue2-datepicker';
    import Multiselect from 'vue-multiselect';
    import AdviserSelector from "@/components/users/AdviserSelector";
    import ExportActions from '@/components/ExportActions';

    Vue.use(ClientTable);

    export default {
        name: "ListQueryRatings",
        components: {
            Vue2DatePicker,
            Multiselect,
            ExportActions,
            AdviserSelector
        },
        data() {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    }
                ],
                queryRatings: [],
                columns: ['uuid', 'adviser', 'avgRating', 'createdAt'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        adviser: 'Asesor',
                        avgRating: 'Valoración Media',
                        createdAt: 'Fecha'
                    },
                    columnsClasses: {
                        uuid: "fit"
                    },
                    sortable: ['adviser', 'avgRating', 'createdAt'],
                    filterable: [],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                theme: 'bootstrap4',
                filters: {
                    dates: null,
                    queryNumber: null,
                    adviser: null,
                    comments: false,
                    contact: false
                },
                datepicker: {
                    shortcuts: [
                        {
                            text: 'Hoy',
                            onClick: () => {
                                let dateStart = new Date();
                                dateStart.setHours(0, 0, 0);
                                let dateEnd = new Date();
                                dateEnd.setHours(23, 59, 59);
                                this.filters.dates = [dateStart, dateEnd]
                            }
                        },
                        {
                            text: 'Últimos 7 días',
                            onClick: () => {
                                let days = 7;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.filters.dates = [last, today]
                            }
                        },
                        {
                            text: 'Últimos 30 días',
                            onClick: () => {
                                let days = 30;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.filters.dates = [last, today]
                            }
                        }
                    ]
                }
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQueryRatings();
            this.$store.dispatch('loadAdvisers');
        },
        computed: {
            ...mapState([
                'advisers'
            ]),
            filteredQueryRatings() {
                return this.queryRatings.filter((queryRating) => {
                    let dateStart = null, dateEnd = null;
                    if (
                        Array.isArray(this.filters.dates)
                        && this.filters.dates.length === 2
                        && this.filters.dates[0] != null
                        && this.filters.dates[1] != null
                    ) {
                        dateStart = this.filters.dates[0];
                        dateEnd = this.filters.dates[1];
                    }

                    return (
                        (!!dateStart && !!dateEnd && queryRating.createdAt >= dateStart && queryRating.createdAt <= dateEnd) || !dateStart || !dateEnd
                    ) && (
                        (!!this.filters.queryNumber && queryRating.query.number == this.filters.queryNumber) || !this.filters.queryNumber
                    ) && (
                        (!!this.filters.adviser && queryRating.adviser.uuid === this.filters.adviser.uuid) || !this.filters.adviser
                    ) && (
                        (this.filters.comments && queryRating.comments) || !this.filters.comments
                    ) && (
                        (this.filters.contact && queryRating.contact) || !this.filters.contact
                    )
                });
            }
        },
        methods: {
            async getQueryRatings() {
                this.$_loadingMixin_showLoading();
                await getQueryRatings()
                    .then((queryRatings) => {
                        this.queryRatings = queryRatings;
                    });
                this.$_loadingMixin_hideLoading();
            },
            getQueryRatingsFilteredData() {
                return this.filteredQueryRatings.map((queryRating) => ({
                    'Asesor': queryRating.adviser.name,
                    'Valoración Media': queryRating.avgRating,
                    'Fecha': queryRating.createdAt.getDate() + '/' + queryRating.createdAt.getMonth() + '/' + queryRating.createdAt.getFullYear()
                }));
            }
        }
    }
</script>

<style scoped>

</style>